export default "__VITE_ASSET__FEBc5$4d__"